import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function isRestrictedByConditionalAccess(): boolean {
    const userConfiguration = getUserConfiguration();
    const attachmentPolicy = userConfiguration.AttachmentPolicy;
    return (
        attachmentPolicy.ConditionalAccessDirectFileAccessOnPrivateComputersBlocked ||
        attachmentPolicy.ConditionalAccessDirectFileAccessOnPublicComputersBlocked ||
        attachmentPolicy.ConditionalAccessPrintWithoutDownloadBlocked ||
        attachmentPolicy.ConditionalAccessWacViewingOnPrivateComputersBlocked ||
        attachmentPolicy.ConditionalAccessWacViewingOnPublicComputersBlocked
    );
}
